import { render, staticRenderFns } from "./ImportBopModelModal.vue?vue&type=template&id=31bc643c&scoped=true"
import script from "./ImportBopModelModal.vue?vue&type=script&lang=ts"
export * from "./ImportBopModelModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc643c",
  null
  
)

export default component.exports